import cx from 'classnames';

import ContentEditable from 'components/common/content-editable/content-editable';
import useButtonsGroup from './use-buttons-group';

import {
  StyledButtonGroup,
  StyledButton,
  StyledPercentWrapper
} from './button-group.style';

type ButtonType = {
  name: string;
  value: string;
};

type ButtonGroupTypes = {
  disabled: boolean;
  reset: boolean;
  afterClick: (val: string) => void;
};

const dataButtons = [
  {
    value: '25',
    name: '25%'
  },
  {
    value: '50',
    name: '50%'
  },
  {
    value: '100',
    name: '100%'
  }
];

const ButtonsGroup = ({
  disabled = false,
  reset = false,
  afterClick
}: ButtonGroupTypes) => {
  const {
    active,
    setActive,
    clickedValue,
    placeholder,
    customValue,
    onChangeValue,
    onBlurHandler,
    handleClick
  } = useButtonsGroup(reset, afterClick);

  return (
    <StyledPercentWrapper
      className={cx({
        'is--disabled': disabled
      })}
    >
      <StyledButtonGroup>
        {dataButtons.map((item: ButtonType) => (
          <StyledButton
            key={item.name}
            onClick={!disabled ? () => handleClick(item.value) : undefined}
            className={cx({
              active: !active && item.value === clickedValue
            })}
          >
            {item.name}
          </StyledButton>
        ))}
      </StyledButtonGroup>
      <ContentEditable
        disabled={disabled}
        placeholder={placeholder}
        onChange={onChangeValue}
        onFocus={() => setActive(true)}
        onBlur={onBlurHandler}
        html={customValue}
      />
    </StyledPercentWrapper>
  );
};

export default ButtonsGroup;
